import { Browser } from '../models';
import {
  SUCCESS_CHECK_BROWSER_SUPPORT,
  FAIL_CHECK_BROWSER_SUPPORT,
  UPDATE_SCREEN_SHARING_EXTENSION_INSTALLED,
} from '../action_types';

const browser = (state = new Browser(), action) => {
  switch (action.type) {
    case SUCCESS_CHECK_BROWSER_SUPPORT:
      return state.set('isWebRTCSupportBrowser', true);
    case FAIL_CHECK_BROWSER_SUPPORT:
      return state.set('isWebRTCSupportBrowser', false);
    case UPDATE_SCREEN_SHARING_EXTENSION_INSTALLED:
      return state.set('isScreenSharingExtensionInstalled', action.payload);
    default:
      return state;
  }
};

export default browser;
